const PartnerSubmissionHeader = () => {
    return (
        <div className={`container-fluid py-2 py-3 d-flex column-gap-3 mb-3 rounded`} >
            <div className="d-flex column-gap-4 col-1 align-items-center"></div>
            <div className="d-flex col-11">
                <div className="col-2  align-self-center">
                    <p className="m-0 fs-4 fw-bold text-black">Supplier's Name</p>
                </div>
                <div className="col-1  align-self-center" >
                    <p className="m-0 fs-4 fw-bold text-black">Match Status</p>
                </div>
                <div className="col-2  align-self-center">
                    <p className="m-0 fs-4 fw-bold text-black">Partner name</p>
                </div>
                <div className="col-1  align-self-center">
                    <p className="m-0 fs-4 fw-bold text-black">Created At</p>
                </div>
                <div className="col-1  align-self-center">
                    <p className="m-0 fs-4 fw-bold text-black">Address 1</p>
                </div>
                <div className="col-1  align-self-center">
                    <p className="m-0 fs-4 fw-bold text-black">City</p>
                </div>
                <div className="col-1  align-self-center">
                    <p className="m-0 fs-4 fw-bold text-black">State</p>
                </div>
                <div className="col-1  align-self-center">
                    <p className="m-0 fs-4 fw-bold text-black">Zip</p>
                </div>
                <div className="col-2 fs-4 align-self-center text-center">
                    <p className="m-0 fs-4 fw-bold text-black">Action</p>
                </div>
            </div>
        </div>
    )
}

export default PartnerSubmissionHeader;